export default __webpack_public_path__ + "static/42q-681a5713fc5ff7e67f67a69b717a9950.jpg";